import AutoComplete from "../forms/AutoComplete";
import React from "react";
import {asyncRemote} from "../../../remote_api/entrypoint";


export function TuiSelectEventSource({
                                         value = null,
                                         disabled = false,
                                         errorMessage = null,
                                         onSetValue = null,
                                         fullWidth = false,
                                         onlyValueWithOptions = true,
                                         type = null
                                     }) {

    const [displayValue, setDisplayValue] = React.useState(value);

    React.useEffect(() => {
        setDisplayValue(value);
        const sourceId = value?.id;
        if (sourceId && (!value?.name || value.name === sourceId)) {
            asyncRemote({url: `/event-source/${sourceId}`, method: "GET"})
                .then(resp => {
                    const name = resp?.data?.name || resp?.data?.id || sourceId;
                    const type = resp.data.type || resp.data.source_type || [];
                    const updated = {
                        ...value,
                        name,
                        type
                    };
                    setDisplayValue(updated);
                    if (onSetValue) {
                        onSetValue(updated);
                    }
                })
                .catch(err => {
                    console.error("Failed to load event source", err);
                });
        }
    }, [value?.id, value?.name, onSetValue]);

    const handleValueSet = (val) => {
        setDisplayValue(val)
        if (onSetValue) {
            onSetValue(val)
        }
    };

    const changeProp = onlyValueWithOptions ? {onSetValue: handleValueSet} : {
        onChange: handleValueSet,
        onSetValue: handleValueSet
    };

    const url = (type) => {
        if(type) {
            return "/event-sources/entity?type=" + type
        }
        return "/event-sources/entity"
    };

    return <div>
        <AutoComplete disabled={disabled}
                      onlyValueWithOptions={onlyValueWithOptions}
                      placeholder="Event source"
                      endpoint={{url: url(type)}}
                      initValue={displayValue}
                      value={displayValue}
                      error={errorMessage}
                      fullWidth={fullWidth}
                      {...changeProp}
        />
    </div>;
}
